export function mixArraysWithStep<T1, T2>(
  array1?: T1[],
  array2?: T2[],
  step?: number
): Array<T1 | T2> {
  const STEP = step ?? 4;
  const _array1 = [...(array1 || [])];
  const _array2 = [...(array2 || [])];
  const result: Array<T1 | T2> = [];
  const allItemsLength = _array1.length + _array2.length;

  for (let i = 0; i < allItemsLength; i++) {
    const item1 = _array1[0];
    const item2 = _array2[0];

    if (item2 && i > 0 && i % STEP === 0) {
      result.push(item2);
      _array2.shift();
    } else if (item1) {
      result.push(item1);
      _array1.shift();
    } else if (item2) {
      result.push(item2);
      _array2.shift();
    }
  }

  return result;
}
